import { v4 as uuidv4, validate } from "uuid";

export const getUuidv4 = () => uuidv4();

export const isValidUuid = (uuid) => validate(uuid);
